export const DEFAULT_ALLOWED_SLIPPAGE = 0.1

export const SupportedNetWork: any = [
    {
        "baseCoin": "USDC",
        "chainId": 1,
        "chainIdHex": "0x1",
        "cmcCoinId": 1027,
        "decimals": 18,
        "explorer": "https://etherscan.io",
        "extension": "-ERC20",
        "fallBack": "https://eth-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "name": "Ethereum",
        "publicRPC": "https://eth-mainnet.g.alchemy.com/v2/FSlkHQ_dE28j0eRSQTyPQICifpxBVQKd",
        "queryToken": "0x5e227AD1969Ea493B43F840cfF78d08a6fc17796",
        "rpc": "https://eth-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "symbol": "ETH",
        "transactionPath": "/tx",
        "nativeCurrency": {
            "name": "Ether",
            "symbol": "ETH",
            "decimals": 18
        }
    },
    {
        "baseCoin": "USDT",
        "chainId": 56,
        "chainIdHex": "0x38",
        "cmcCoinId": 1839,
        "decimals": 18,
        "explorer": "https://bscscan.com",
        "extension": "-BEP20",
        "fallBack": "https://bnb-mainnet.g.alchemy.com/v2/LtlgVwoeT2d36xhKGwI93l0LU8i84t1o",
        "farmToken": "",
        "name": "BSC",
        "publicRPC": "https://bnb-mainnet.g.alchemy.com/v2/LtlgVwoeT2d36xhKGwI93l0LU8i84t1o",
        "queryToken": "0x7e8b5b722f1a3c5ab2bd8510eaba24dae97565d1",
        "rpc": "https://bnb-mainnet.g.alchemy.com/v2/LtlgVwoeT2d36xhKGwI93l0LU8i84t1o",
        "symbol": "BNB",
        "transactionPath": "/tx",
        "nativeCurrency":{
            "decimals": 18,
            "name": "BNB",
            "symbol": "BNB"
        }
    },
    {
        "baseCoin": "USDT",
        "chainId": 42161,
        "chainIdHex": "0xa4b1",
        "cmcCoinId": 11841,
        "decimals": 18,
        "explorer": "https://arbiscan.io",
        "extension": "-ARBITRUM",
        "fallBack": "https://arb-mainnet.g.alchemy.com/v2/nVV_qQYHOM_Ps6hVGU2rE4_0w8zlBDBm",
        "name": "Arbitrum",
        "publicRPC": "https://arb1.arbitrum.io/rpc",
        "rpc": "https://arb-mainnet.g.alchemy.com/v2/nVV_qQYHOM_Ps6hVGU2rE4_0w8zlBDBm",
        "symbol": "ARB",
        "transactionPath": "/tx",
        "nativeCurrency": {
            "name": "Ether",
            "symbol": "ETH",
            "decimals": 18
        }
    },
    {
        "baseCoin": "USDT",
        "chainId": 10,
        "chainIdHex": "0xa",
        "cmcCoinId": 11840,
        "decimals": 18,
        "name": "Optimism",
        "explorer": "https://explorer.optimism.io",
        "publicRPC": "https://mainnet.optimism.io",
        "rpc": "https://opt-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "symbol": "OP",
        "transactionPath": "/tx",
        "nativeCurrency": {
            "name": "Ether",
            "symbol": "ETH",
            "decimals": 18
        }
    },
    {
        "chainId": 43114,
        "name": "Avalanche",
        "symbol": "AVAX",
        "explorer": "https://snowtrace.io/",
        "publicRPC": "https://api.avax.network/ext/bc/C/rpc",
        "rpc": "https://avax-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "nativeCurrency": {
            "decimals": 18,
            "name": "Avalanche",
            "symbol": "AVAX"
        }
    },
    {
        "baseCoin": "USDT",
        "chainId": 8453,
        "chainIdHex": "0x2105",
        "cmcCoinId": 27716,
        "decimals": 18,
        "explorer": "https://basescan.org",
        "name": "BASE",
        "publicRPC": "https://base-mainnet.g.alchemy.com/v2/KipxrhiCVxOIF6vrcR18k5VzTneU4mJb",
        "rpc": "https://base-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "symbol": "BASE",
        "transactionPath": "/tx",
        "nativeCurrency": {
            "name": "Ether",
            "symbol": "ETH",
            "decimals": 18
        }
    },
        {
            "chainId": 100,
            "name": "Gnosis",
            "symbol": "GNO",
            "explorer": "https://gnosisscan.io",
            "publicRPC": "https://rpc.gnosischain.com/",
            "rpc": "https://gnosis-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
            "nativeCurrency": {
                "decimals": 18,
                "name": "xDAI",
                "symbol": "XDAI"
            }
        },  {
            "chainId": 146,
            "name": "Sonic",
            "symbol": "S",
        "explorer": "https://sonicscan.org",
        "publicRPC": "https://rpc.soniclabs.com",
        "rpc": "https://sonic-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
        "nativeCurrency": {
            "decimals": 18,
            "name": "Sonic",
            "symbol": "S"
        }
        },
        {
            "chainId": 130,
            "name": "Unichain",
            "symbol": "UNI",
            "explorer": "https://uniscan.xyz",
            "publicRPC": "https://mainnet.unichain.org/",
            "rpc": "https://unichain-mainnet.g.alchemy.com/v2/kZkfDUn1kdREcw7Nipkjr_FhbYzKwXJh",
            "nativeCurrency": {
                "name": "Ether",
                "symbol": "ETH",
                "decimals": 18
            }
        },
]

export const NATIVE_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
